import { createSelector } from 'reselect';
import PredesPlannedTransportAnomaliesDestinationSummaryColumns
  from '../../containers/PredesPlannedTransportAnomaliesDestinationSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesPlannedTransportAnomaliesDestinationSummaryColumns);
